module.exports = __webpack_public_path__ + "static/img/summary-wap.5b40e8b5.png";